module.exports = __webpack_public_path__ + "static/img/OST-Logo_DE.2943d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/OST-Logo_DE.png
// module id = 57
// module chunks = 1